<template>
  <h1>Edit Events Page</h1>
</template>

<script>
export default {
  props: ["event"],
};
</script>
